// extracted by mini-css-extract-plugin
module.exports = {"container":"Callout__container--Ut67r","exclamation":"Callout__exclamation--365Uz"};